import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { formatDescription } from '../../../../../lib/utils/utils';

function FeatureSection({ feature }) {
    const [iconSize, setIconSize] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [headingSize, setHeadingSize] = useState(0);
    const [headingHeight, setHeadingHeight] = useState(0);

    const [descSize, setDescSize] = useState(0);
    const [descHeight, setDescHeight] = useState(0);

    const [gap, setGap] = useState(0);
    const [textGap, setTextGap] = useState(0);

    useEffect(() => {
        setIconSize((zoomSize/100)*28);

        setHeadingSize((zoomSize/100)*16);
        setHeadingHeight((zoomSize/100)*26);

        setDescSize((zoomSize/100)*12);
        setDescHeight((zoomSize/100)*22);

        setGap((zoomSize/100)*12);
        setTextGap((zoomSize/100)*8);
    }, [zoomSize]);

    return (
        <div style={{ gap: `${gap}px` }} className="flex">
            <div style={{ width: `${iconSize}px`, height: `${iconSize}px` }}>
                <img className='size-full' src={feature?.imageLink} alt={feature.altText} />
            </div>

            <div style={{ width: `calc(100% - ${iconSize}px)`, gap: `${textGap}px` }} className="flex flex-col">
                <h1 style={{ fontSize: `${headingSize}px`, lineHeight: `${headingHeight}px` }} className='font-semibold text-[#212121]'>{feature.Heading}</h1>

                <p style={{ fontSize: `${descSize}px`, lineHeight: `${descHeight}px` }} className='font-medium text-[#212121]'>
                    <span dangerouslySetInnerHTML={{ __html: formatDescription(feature.Description || '') }} />
                </p>
            </div>
        </div>
    );
}

function FeaturesOne({ item }) {
    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [gap, setGap] = useState(0);
    const [paddingSide, setPaddingSide] = useState(0);

    useEffect(() => {
        setGap((zoomSize/100)*12);
        setPaddingSide((zoomSize/100)*16);
    }, [zoomSize]);

    return (
        <div 
            style={{ gap: `${gap}px`, paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px` }} 
            className='flex flex-col relative'
        >
            {item.item.featureItems.map((feature, index) => {
                return (
                    <FeatureSection 
                        key={index} 
                        feature={feature}
                    />
                )
            })}
        </div>
    );
}

export default FeaturesOne;
